import React from 'react'
import { Box } from '@mui/material'
import { StyledTabs, StyledTab, StyledComponentSection } from './styled.js'

export const CommonTabs = ({ id, tabs = [], value, onChange }) => {
  const a11y = index => ({
    id: `${id}-tab-${index}`,
    'aria-controls': `${id}-tabpanel-${index}`,
  })

  return (
    <>
      <StyledTabs
        value={value}
        onChange={onChange}
        aria-label={`${id}-tabs`}
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
      >
        {tabs.map((t, index) => (
          <StyledTab key={index} label={t.label} {...a11y(index)} />
        ))}
      </StyledTabs>
      {tabs.map((t, index) => (
        <div
          key={index}
          role='tabpanel'
          hidden={value !== index}
          id={`${id}-tabpanel-${index}`}
          aria-labelledby={`${id}-tab-${index}`}
        >
          {value === index && (
            <StyledComponentSection>{t.content}</StyledComponentSection>
          )}
        </div>
      ))}
    </>
  )
}
